import React, { useState } from "react";
import axios from "axios";
import { getToken, base_url } from "../../config/config";

const IncomingInvoiceForm = () => {
  const [formData, setFormData] = useState({
    ANR: "",
    AdditionalText: "",
    Einzelpreis: "",
    totalHours: "",
    costByUser: "",
    profitOrLoss: "",
    invoiceNo: "",
    Menge: 0,
    Gesamtpreis: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Convert numerical inputs to numbers where appropriate
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "Einzelpreis" || name === "Menge" || name === "Gesamtpreis"
          ? Number(value)
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${base_url}/v1/createExcelBulk`,
        formData,
      );
      console.log("Record created:", response.data);
      // Optionally reset the form after successful submission
      setFormData({
        ANR: "",
        AdditionalText: "",
        Einzelpreis: "",
        totalHours: "",
        costByUser: "",
        profitOrLoss: "",
        invoiceNo: "",
        Menge: 0,
        Gesamtpreis: 0,
      });
    } catch (error) {
      console.error("Error creating record:", error);
    }
  };

  return (
    <div className='max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md'>
      <h2 className='text-2xl font-semibold text-gray-800 mb-6'>
        Invoice Data Entry
      </h2>
      <form onSubmit={handleSubmit} className='space-y-4'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              ANR:
            </label>
            <input
              type='text'
              name='ANR'
              value={formData.ANR}
              onChange={handleChange}
              required
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Additional Text:
            </label>
            <input
              type='text'
              name='AdditionalText'
              value={formData.AdditionalText}
              onChange={handleChange}
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Einzelpreis:
            </label>
            <input
              type='number'
              name='Einzelpreis'
              value={formData.Einzelpreis}
              onChange={handleChange}
              required
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Total Hours:
            </label>
            <input
              type='text'
              name='totalHours'
              value={formData.totalHours}
              onChange={handleChange}
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Cost By User:
            </label>
            <input
              type='text'
              name='costByUser'
              value={formData.costByUser}
              onChange={handleChange}
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Profit Or Loss:
            </label>
            <input
              type='text'
              name='profitOrLoss'
              value={formData.profitOrLoss}
              onChange={handleChange}
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Invoice No:
            </label>
            <input
              type='text'
              name='invoiceNo'
              value={formData.invoiceNo}
              onChange={handleChange}
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Menge:
            </label>
            <input
              type='number'
              name='Menge'
              value={formData.Menge}
              onChange={handleChange}
              min='0'
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>

          <div className='space-y-2'>
            <label className='block text-sm font-medium text-gray-700'>
              Gesamtpreis:
            </label>
            <input
              type='number'
              name='Gesamtpreis'
              value={formData.Gesamtpreis}
              onChange={handleChange}
              className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            />
          </div>
        </div>

        <div className='pt-4'>
          <button
            type='submit'
            className='w-full md:w-auto px-6 py-2 bg-blue-600 text-white font-medium rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors'>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default IncomingInvoiceForm;
